import * as React from 'react';
import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/components/View';
import { CardWrapper } from 'foundations-components/transitional/components/Card';
import { H3 } from 'foundations-components/transitional/components/H3';
import { H7 } from 'foundations-components/transitional/components/H7';
import { Image } from 'foundations-components/transitional/components/Image';
import { List, ListItem } from 'foundations-components/transitional/components/List';
import { Small } from 'foundations-components/transitional/components/Small';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { FormattedIntlCurrency } from 'I18n/components/FormattedIntlCurrency';
import { SkeletonBlock } from '../../components/Skeletons/subcomponents/Skeleton';
// @ts-expect-error Not yet migrated
import arrowCircleUrl from 'bender-url!../../../images/left-arrow-circle.svg';
// @ts-expect-error Not yet migrated
import checkmarkCircleUrl from 'bender-url!../../../images/checkmark-circle.svg';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const colorByLevel = {
  free: 'text-core-subtle',
  starter: 'fill-caution-default',
  pro: 'fill-positive-default',
  enterprise: 'fill-accent-teal-default'
};
const PricingCard = ({
  level,
  features,
  currency,
  price,
  isCurrentPlan = false,
  priceLoading = false
}) => {
  const currentPlanStyleProps = isCurrentPlan ? {
    backgroundColor: 'fill-tertiary-default',
    padding: '200',
    marginInlineStart: '-200',
    marginInlineEnd: '-200',
    borderWidth: '100',
    borderStyle: 'solid',
    borderColor: 'border-core-subtle',
    borderRadius: '200'
  } : {};
  return /*#__PURE__*/_jsx("div", {
    children: /*#__PURE__*/_jsxs(Flex, Object.assign({
      alignItems: "center",
      flexDirection: "column",
      marginBlockEnd: isCurrentPlan ? '200' : '400',
      marginBlockStart: isCurrentPlan ? '0' : '900'
    }, currentPlanStyleProps, {
      children: [isCurrentPlan && /*#__PURE__*/_jsx(Small, {
        marginBlockEnd: "200",
        weight: "bold",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.softwareDesirability.modal.pricingSection.currentPlan"
        })
      }), /*#__PURE__*/_jsxs(CardWrapper, {
        blockSize: "485px",
        borderBlockStartColor: colorByLevel[level],
        borderBlockStartStyle: "solid",
        borderBlockStartWidth: "300",
        inlineSize: "100vw",
        marginBlockEnd: "0",
        maxInlineSize: "250px",
        textAlign: "left",
        children: [/*#__PURE__*/_jsxs(View, {
          blockSize: "130px",
          borderBlockEndColor: "border-core-subtle",
          borderBlockEndStyle: "solid",
          borderBlockEndWidth: "100",
          textAlign: "center",
          children: [/*#__PURE__*/_jsx(H3, {
            marginBlockEnd: "200",
            marginBlockStart: "700",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: `learningCenter.softwareDesirability.modal.pricingSection.${level}`
            })
          }), priceLoading ? /*#__PURE__*/_jsx(View, {
            inlineSize: "fit-content",
            margin: "auto",
            textAlign: "center",
            children: /*#__PURE__*/_jsx(SkeletonBlock, {
              height: "14px",
              width: "150px"
            })
          }) : price !== null && /*#__PURE__*/_jsx(Small, {
            use: "help",
            children: /*#__PURE__*/_jsx(FormattedReactMessage, {
              message: level === 'free' ? `learningCenter.softwareDesirability.modal.pricingSection.pricingFree` : `learningCenter.softwareDesirability.modal.pricingSection.pricingPaid`,
              options: {
                price: /*#__PURE__*/_jsx(FormattedIntlCurrency, {
                  abbreviate: true,
                  abbreviateThreshold: 100000,
                  currencyCode: currency,
                  maximumFractionDigits: 3,
                  stripInsignificantZeros: false,
                  trailingZeroDisplay: "stripIfInteger",
                  value: price
                })
              }
            })
          }), level === 'free' && /*#__PURE__*/_jsx(Small, {
            use: "help",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "learningCenter.softwareDesirability.modal.pricingSection.noCreditCard"
            })
          })]
        }), /*#__PURE__*/_jsxs(View, {
          children: [/*#__PURE__*/_jsx(H7, {
            marginBlockEnd: "500",
            marginBlockStart: "400",
            textAlign: "center",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "learningCenter.softwareDesirability.modal.pricingSection.popularFeatures"
            })
          }), /*#__PURE__*/_jsx(List, {
            children: features.map((feature, i) => /*#__PURE__*/_jsxs(ListItem, {
              marginBlockEnd: "300",
              paddingInline: "500",
              children: [/*#__PURE__*/_jsx(Flex, {
                backgroundColor: level !== 'free' && i === 0 ? colorByLevel[level] : colorByLevel['free'],
                blockSize: "16px",
                borderRadius: "full",
                display: "inline-flex",
                inlineSize: "16px",
                insetBlockStart: "100",
                marginBlockEnd: "50",
                marginInlineEnd: "200",
                position: "relative",
                children: /*#__PURE__*/_jsx(Image, {
                  display: "inline-block",
                  shape: "circle",
                  src: level !== 'free' && i === 0 ? arrowCircleUrl : checkmarkCircleUrl
                })
              }), feature]
            }, i))
          })]
        })]
      })]
    }))
  });
};
export default PricingCard;